import { animated, useSpring } from "react-spring";
import { springConfigs } from "../../../constants/springConfigs";
import { useWindowSize } from "../../../hooks/useWindowSize";

const MenuTitle = ({ menuTitle }) => {
  const { marginTop } = useSpring({
    from: { marginTop: "30px" },
    to: { marginTop: "0px" },
    config: springConfigs.textAppears,
  });
  const { h, w, horizontal } = {
    ...useWindowSize(),
  };

  // console.log({ horizontal }, h(8));

  return (
    <div
      {...{
        style: {
          height: horizontal ? h(8) : h(8),
          overflow: "hidden",
          marginLeft: `-${w(0.1)}`,
        },
      }}
    >
      <animated.div
        style={{
          overflow: "hidden",
          display: "flex",
          marginTop,
          fontSize: horizontal ? h(4.5) : h(6),
          lineHeight: horizontal ? h(4.5) : h(6),
          fontWeight: "700",
          letterSpacing: "-0.05em",
        }}
      >
        {menuTitle}
      </animated.div>
    </div>
  );
};

export default MenuTitle;
